import Product from '@common/models/Product';
import ArrowDown from '@images/ArrowDown.svg';
import Image from '@lib/Image';
// import Rupee from '@instamojo/rupee';
// import Button from '@lib/Button';
import classnames from 'classnames';
import React, { useState } from 'react';

// import Savings from '../Tags/Savings';

interface SelectVariantsProps {
  product: Product;
  selectedOptions: Array<number>;
  setSelectedOptions: (selectedOptions: Array<number>) => void;
  quantity: number;
  setQuantity: (quantity: number) => void;
  isQuickView: boolean;
}

const SelectVariants: React.FC<SelectVariantsProps> = ({
  product,
  selectedOptions,
  setSelectedOptions,
  className,
  quickView,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(null);
  const [isHover, setIsHover] = useState(null);
  return (
    <div className={className}>
      {product.optionNames.map((optionName, index) => (
        <div
          className={classnames({
            'flex items-center justify-between mb-16 last:mb-0': quickView,
          })}
          key={optionName}
        >
          <div
            className={classnames('mb-8 text-heading text-14', {})}
            font-customisation="section-heading"
            color-customisation="page-heading"
            id={'variant-type-' + (parseInt(index) + 1)}
          >
            {optionName}
          </div>
          {quickView
            ? DropDownoptionsBar(
                product,
                index,
                selectedOptions,
                setSelectedOptions,
                isDropdownOpen,
                setIsDropdownOpen,
                isHover,
                setIsHover,
              )
            : OtheroptionsBar(product, index, selectedOptions, setSelectedOptions)}
        </div>
      ))}
    </div>
  );
};

//ColoroptionsBar
// const ColoroptionsBar = (designType, product, index, selectedOptions, setSelectedOptions) => {
//   return (
//     <div className="flex flex-wrap">
//       {product.allOptionValues[index].map((optionValue, optionIndex) => (
//         <div
//           key={optionValue}
//           className={classnames('cursor-pointer rounded-full mb-12 mr-2 p-2', {
//             'border-solid border-2 border-black': optionIndex === selectedOptions[index],
//             'border-none': optionIndex !== selectedOptions[index],
//           })}
//           onClick={() => {
//             console.log(selectedOptions[index], optionIndex);
//             const newSelectedOptions = [...selectedOptions];
//             newSelectedOptions[index] = optionIndex;
//             setSelectedOptions(newSelectedOptions);
//           }}
//         >
//           <div
//             className={classnames('cursor-pointer w-12 h-12 rounded-full')}
//           ></div>
//         </div>
//       ))}
//     </div>
//   );
// };

//OtheroptionsBar
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const OtheroptionsBar = (product, index, selectedOptions, setSelectedOptions) => {
  return (
    <div className="flex flex-wrap justify-center md:justify-start">
      {product?.allOptionValues[index]?.map((optionValue, optionIndex) => (
        <div
          key={optionValue}
          className={classnames('cursor-pointer text-16  mb-12 rounded-full px-16 py-6 mr-10 last:mr-0', {
            'text-white  bg-variant-selectedBg border-variant-selectedBg': optionIndex === selectedOptions[index],
            'text-body  bg-white border border-variant-border': optionIndex !== selectedOptions[index],
          })}
          onClick={() => {
            const newSelectedOptions = [...selectedOptions];
            newSelectedOptions[index] = optionIndex;
            setSelectedOptions(newSelectedOptions);
          }}
          id={'type' + (parseInt(index) + 1) + '-v' + (parseInt(optionIndex) + 1)}
        >
          {optionValue}
        </div>
      ))}
    </div>
  );
};
const DropDownoptionsBar = (
  product,
  index,
  selectedOptions,
  setSelectedOptions,
  isDropdownOpen,
  setIsDropdownOpen,
  isHover,
  setIsHover,
) => {
  return (
    <div
      tabIndex={0}
      onBlur={(e) => {
        e.preventDefault();
        setIsDropdownOpen(null);
      }}
      className="focus:outline-none justify-self-end md:justify-self-auto"
    >
      <div className="flex flex-col">
        <div className="flex items-center">
          <div
            className={classnames(
              'flex justify-between cursor-pointer items-center flex-wrap focus:outline-none border border-border w-180 min-w-180 px-14 py-10',
            )}
            onClick={(e) => {
              e.preventDefault();
              isDropdownOpen === index ? setIsDropdownOpen(null) : setIsDropdownOpen(index);
            }}
          >
            <span
              className="text-16 leading-22 font-normal text-heading"
              color-customisation="page-body-text"
              id={
                'type' +
                (parseInt(index) + 1) +
                '-v' +
                (parseInt(
                  product?.allOptionValues[index]?.indexOf(product?.allOptionValues[index]?.[selectedOptions[index]]),
                ) +
                  1)
              }
            >
              {product?.allOptionValues[index]?.[selectedOptions[index]]}
            </span>
            <div className="cursor-pointer">
              <Image
                className={classnames('object-contain min-w-10', { 'transform rotate-180': isDropdownOpen === index })}
                src={ArrowDown}
                noDefaultDimensions
                alt="Down"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="">
        {isDropdownOpen === index && (
          <div
            className={classnames(
              'flex cursor-pointer absolute flex-col mt-4 overflow-y-scroll border border-border bg-white z-40',
              {
                'w-180 min-w-180': true,
              },
            )}
            onMouseLeave={(e) => {
              e.preventDefault();
              setIsDropdownOpen(null);
            }}
            onBlur={(e) => {
              e.preventDefault();
              setIsHover(null);
            }}
          >
            {product?.allOptionValues[index]?.map((optionValue, optionIndex) => (
              <>
                {product?.allOptionValues[index]?.[selectedOptions[index]] !== optionValue && (
                  <div
                    className="flex hover:bg-beige text-heading text-16 leading-22 font-normal pl-10 min-h-40 items-center focus:bg-opacity-15 focus:bg-textColor"
                    key={optionValue}
                    onClick={() => {
                      const newSelectedOptions = [...selectedOptions];
                      newSelectedOptions[index] = optionIndex;
                      setSelectedOptions(newSelectedOptions);
                      setIsDropdownOpen(null);
                    }}
                    color-customisation="page-body-text"
                    id={'type' + (parseInt(index) + 1) + '-v' + (parseInt(optionIndex) + 1)}
                  >
                    {optionValue}
                  </div>
                )}
              </>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
export default SelectVariants;
